import React from 'react';

import Presentacion from './comps/Presentacion';
import PrimeraParte from './comps/PrimeraParte';
import Solicitar from './comps/Solicitar';
import MasProductosSS from './comps/MasProductosSS';

const SmartSuiteDeclarative = ({ t }) => {
  return (
    <>
      <Presentacion t={t} />
      <PrimeraParte t={t} />
      <MasProductosSS t={t} />      
      <Solicitar t={t} />

    </>
  );
};

export default SmartSuiteDeclarative;
